<template>
  <el-popover
    placement="bottom-end"
    width="160"
    trigger="click"
    v-model="visible"
  >
    <div class="op-column-setting">
      <el-checkbox
        v-for="(item, key) in columnConfig"
        :key="key"
        v-model="columnShow[key]"
        @change="handleChange"
      >{{ item.label }}</el-checkbox>
    </div>
    <el-button size="mini" icon="el-icon-setting" slot="reference">列设置</el-button>
  </el-popover>
</template>

<script>
export default {
  name: "OpColumnSetting",
  props: {
    // 列配置对象，格式与现有页面完全兼容
    columnConfig: {
      type: Object,
      required: true
    },
    // 列显隐状态，支持v-model双向绑定
    value: {
      type: Object,
      required: true
    },
    // 表格ref实例，自动刷新布局
    tableRef: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    columnShow: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleChange() {
      this.$nextTick(() => {
        if (this.tableRef) {
          this.tableRef.doLayout();
        }
      });
      this.$emit('change', this.columnShow);
    }
  }
}
</script>